// AddHotelForm.js
import React, { useState } from "react";
import axios from "axios";
import "../css/AddHotel.css";

const AddHotelForm = ({ onClose, onHotelAdded }) => {
  const API_URL = process.env.REACT_APP_API_URL;

  const [formData, setFormData] = useState({
    global_hotel_name: "",
    global_address: "",
    managed_by: "",
    contact_person_name: "",
    contact_email: "",
    contact_phone: "",
    website_url: "",
    description: "",
  });

  const [file, setFile] = useState(null);
  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  const handleFileChange = (e) => setFile(e.target.files[0]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (isSubmitting) return;

    // Validate required fields
    const requiredFields = ["global_hotel_name", "global_address", "managed_by", "contact_person_name", "contact_email", "contact_phone"];
    for (let field of requiredFields) {
      if (!formData[field]) {
        alert(`Please fill in ${field.replace("_", " ")}`);
        return;
      }
    }

    setIsSubmitting(true);
    try {
      const fd = new FormData();
      Object.keys(formData).forEach(key => fd.append(key, formData[key]));
      if (file) fd.append("photo_uploads", file);

      const res = await axios.post(`${API_URL}/ems/global-hotels`, fd, {
        headers: { "Content-Type": "multipart/form-data" },
      });

      alert("Hotel added successfully!");
      onHotelAdded?.();
      onClose();
    } catch (err) {
      console.error("Error adding hotel:", err);
      alert("Failed to add  hotel.");
      setIsSubmitting(false);
    }
  };

  return (
    <div className="modal show d-block" tabIndex="-1" style={{ backgroundColor: "rgba(0,0,0,0.4)" }}>
      <div className="modal-dialog modal-md add-hotel-modal">
        <div className="modal-content">
          <div className="modal-header">
            <h5 className="modal-title">Add Hotel</h5>
          </div>

          <div className="modal-body add-hotel">
            <div className="mb-3">
                <label className="form-label">Hotel Name <span className="text-danger">*</span></label>
              <input type="text" name="global_hotel_name" className="form-control" placeholder="Enter hotel name" value={formData.global_hotel_name} onChange={handleChange} required />
            </div>

            <div className="mb-3">
              <label className="form-label">Address <span className="text-danger">*</span></label>
              <input type="text" name="global_address" className="form-control" placeholder="Enter address" value={formData.global_address} onChange={handleChange} required />
            </div>

            <div className="mb-3">
              <label className="form-label">Managed By <span className="text-danger">*</span></label>
              <select name="managed_by" className={"form-control" + (formData.managed_by ? "" : " select-placeholder")} value={formData.managed_by} onChange={handleChange} required>
                <option value="">Select...</option>
                <option value="IGF">IGF</option>
                <option value="LOCOG">LOCOG</option>
              </select>
            </div>

            <div className="mb-3">
              <label className="form-label">Contact Person Name <span className="text-danger">*</span></label>
              <input type="text" name="contact_person_name" className="form-control" placeholder="Enter contact person name" value={formData.contact_person_name} onChange={handleChange} required />
            </div>

            <div className="mb-3">
              <label className="form-label">Contact Email <span className="text-danger">*</span></label>
              <input type="email" name="contact_email" className="form-control" placeholder="e.g. contact@hotel.com" value={formData.contact_email} onChange={handleChange} required />
            </div>

            <div className="mb-3">
              <label className="form-label">Contact Phone <span className="text-danger">*</span></label>
              <input type="text" name="contact_phone" className="form-control" placeholder="e.g. +1 234 567 8900" value={formData.contact_phone} onChange={handleChange} required />
            </div>

            <div className="mb-3">
              <label className="form-label">Website URL</label>
              <input type="text" name="website_url" className="form-control" placeholder="e.g. https://www.hotel.com" value={formData.website_url} onChange={handleChange} />
            </div>

            <div className="mb-3">
              <label className="form-label">Description</label>
              <textarea name="description" className="form-control" placeholder="e.g. Brief description of the hotel" value={formData.description} onChange={handleChange} />
            </div>

            <div className="mb-3">
              <label className="form-label">Upload Photo</label>
              <input type="file" accept="image/*" className="form-control" onChange={handleFileChange} />
            </div>
          </div>

          <div className="modal-footer">
            <button onClick={handleSubmit} disabled={isSubmitting} className="btn" style={{ backgroundColor: "#d9a128ba", color: "#fff", border: "none", fontWeight: "bold" }}>{isSubmitting ? "Adding..." : "Add"}</button>
            <button onClick={onClose} disabled={isSubmitting} className="btn" style={{ backgroundColor: "#000", color: "#fff", border: "none" }}>Cancel</button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AddHotelForm;
